import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconStationary.module.css';

const IconStationary = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 3C4.73122 3 3.5 4.23122 3.5 5.75V6.79832L3.30981 7.10038C3.01082 7.57523 2.73056 7.938 2.45537 8.2942C2.30594 8.48762 2.15801 8.67911 2.00939 8.88555C1.62175 9.42399 1.25 10.0478 1.25 10.84C1.25 12.1223 2.24642 13.1593 3.5 13.2444V21H20.5V13.2444C21.7536 13.1594 22.75 12.1223 22.75 10.84C22.75 10.0478 22.3782 9.42399 21.9906 8.88556C21.8421 8.67918 21.6942 8.48774 21.5448 8.29436C21.2696 7.93815 20.9892 7.57527 20.6903 7.1004L20.5 6.7982V5.75C20.5 4.23122 19.2688 3 17.75 3H6.25ZM19 6.75V5.75C19 5.05964 18.4404 4.5 17.75 4.5H6.25C5.55964 4.5 5 5.05964 5 5.75V6.75H19ZM19 12.8511C18.8811 12.7727 18.7696 12.6841 18.6667 12.5865C18.2325 12.9983 17.645 13.25 17 13.25C16.355 13.25 15.7676 12.9983 15.3334 12.5865C14.8992 12.9983 14.3117 13.25 13.6667 13.25C13.0217 13.25 12.4342 12.9983 12 12.5865C11.5658 12.9983 10.9784 13.25 10.3334 13.25C9.68837 13.25 9.10089 12.9983 8.6667 12.5865C8.23251 12.9983 7.64503 13.25 7.00003 13.25C6.35503 13.25 5.76755 12.9983 5.33336 12.5865C5.23043 12.6841 5.11888 12.7727 5 12.8511V19.5H19V12.8511ZM7.00003 11.75C6.48985 11.75 6.08337 11.3423 6.08337 10.84L6.08333 10.25L4.58333 10.25L4.58337 10.84C4.58334 11.3424 4.17686 11.75 3.66667 11.75C3.15648 11.75 2.75 11.3423 2.75 10.84C2.75 10.5422 2.87825 10.246 3.22673 9.76195C3.32397 9.62688 3.44441 9.47039 3.57871 9.29588C3.81028 8.99496 4.08311 8.64045 4.34921 8.25H19.6508C19.9169 8.64048 20.1897 8.99496 20.4213 9.29588C20.5556 9.47038 20.676 9.62688 20.7733 9.76194C21.1218 10.246 21.25 10.5422 21.25 10.84C21.25 11.3424 20.8435 11.75 20.3334 11.75C19.8232 11.75 19.4167 11.3424 19.4167 10.84V10.25H17.9167V10.84C17.9167 11.3423 17.5102 11.75 17 11.75C16.4898 11.75 16.0834 11.3423 16.0834 10.84V10.25H14.5834V10.84C14.5834 11.3423 14.1769 11.75 13.6667 11.75C13.1565 11.75 12.75 11.3423 12.75 10.84V10.25H11.25V10.84C11.25 11.3423 10.8436 11.75 10.3334 11.75C9.82318 11.75 9.4167 11.3423 9.4167 10.84V10.25H7.9167V10.84C7.9167 11.3423 7.51022 11.75 7.00003 11.75Z"
        fill="#333333"
      />
    </svg>
  );
};

IconStationary.defaultProps = { className: null };

IconStationary.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconStationary;
